import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import { environment as env } from "@environments/environment";
import { COUNTRY_CODE } from "@environments/environment.type";
import { Observable, of } from "rxjs";

@Injectable()
export class RegionGuard implements CanActivate {
  constructor(protected router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const unavailableRegions: string[] = route.data.unavailableRegions as COUNTRY_CODE[];

    const unavailable = !unavailableRegions.includes(env.code);
    if (!unavailable) {
      this.router.navigate(["/dashboard/orders"]);
    }
    return of(unavailable);
  }
}
